import { TransactionType } from '../../entities/transactions-v1/query-types';
import { GlobalPreferences } from '../../entities/user-preferences-v2/global-preferences';

export type FilterSet = {
  title: string;
  appliedOnLoad: boolean;
  active?: boolean;
  open?: boolean;
  editing?: boolean;
  filters?: string[];
  activeFileTypeFilter?: TransactionType;
  isNotdeletable?: boolean;
};

type SessionHistory = {
  [key: string]: { deviceId: string; queryString: string };
};

export interface CustomUserPreferences { 
  [key: string]: string;
}

export interface UserPreference {
  globalUserPreferences: GlobalPreferences;
  customUserPreferences: CustomUserPreferences;
  sessionHistory: SessionHistory | null;
}

export interface AppPreferences {
  landingPage?: string;
  isLoading?: boolean;
}

export enum UserPreferenceNames {
  SET_RECENT_USER_SEARCHES = 'SET_RECENT_USER_SEARCHES',
  SET_DISPLAY_NAME = 'SET_DISPLAY_NAME',
  SET_SESSION_HISTORY = 'SET_SESSION_HISTORY',
  SET_TRANSACTION_FILTERS = 'SET_TRANSACTION_FILTERS',
  SET_TIME_FORMAT = 'SET_TIME_FORMAT',
  SET_DATE_FORMAT = 'SET_DATE_FORMAT',
  SET_TIME_ZONE = 'SET_TIME_ZONE',
}

interface SetApplicationPreferences {
  type: typeof UserPreferenceNames.SET_RECENT_USER_SEARCHES;
  payload: string;
}

interface SetSessionHistory {
  type: typeof UserPreferenceNames.SET_SESSION_HISTORY;
  payload: SessionHistory;
}

interface SetUserProfile {
  type: typeof UserPreferenceNames.SET_DISPLAY_NAME;
  payload: string;
}

interface SetTimeFormat {
  type: typeof UserPreferenceNames.SET_TIME_FORMAT;
  payload: GlobalPreferences.TimeFormatEnum;
}

interface SetDateFormat {
  type: typeof UserPreferenceNames.SET_DATE_FORMAT;
  payload: GlobalPreferences.DateFormatEnum;
}

interface SetTimeZone {
  type: typeof UserPreferenceNames.SET_TIME_ZONE;
  payload: string;
}

export type UserPreferenceActionTypes =
  | SetApplicationPreferences
  | SetSessionHistory
  | SetUserProfile
  | SetTimeFormat
  | SetDateFormat
  | SetTimeZone;
